import LandingPageHeroBlack, {
  LandingPageHeroBlackProps
} from '../../../../components/_external-pages/landing/LandingPageHeroBlack';

const props: LandingPageHeroBlackProps = {
  title: 'Lo decimos nosotros y nuestros clientes',
  image: '/static/grupo.webp',
  overlay: '/static/overlay1.svg',
  cards: [
    {
      name: 'Cesar Gonzalez',
      icon: '/static/icons/star.svg',
      rate: 5,
      comment: 'La atencion y recibimiento es muy grato y genera mucha confianza en la empresa.'
    },
    {
      name: 'Josue Sumuano',
      icon: '/static/icons/star.svg',
      rate: 5,
      comment: 'La mejor alternativa. No me cobró comisión por apertura!!!'
    },
    {
      name: 'Rogelio Arturo Hernandez',
      icon: '/static/icons/star.svg',
      rate: 5,
      comment: 'Súper recomendable!! Excelente trato al cliente.'
    }
  ]
};

export const HomeHeroInPageBlack = () => {
  return (
    <>
      <LandingPageHeroBlack {...props} />
    </>
  );
};
